module.exports = __webpack_public_path__ + "img/Santander.e865dd3a.svg";